/* @ngInject */
function LicenseCardController ($scope, $rootScope, $q, $timeout, AdminService, ToastService, UdsModalService) {
  const getRequestQuoteDialogController = () => $q.when(import('../../dialogs/request-quote/request-quote-dialog.controller'))

  $scope.flags = {
    loading: true,
    error: false
  }

  $scope.graphicColor = 'default'

  $scope.planName = ''

  const api = {
    getRequestQuoteDialogController,
    _buildGraphic,
    _getPercentage,
    _defineGraphicColor,
    _getUsersCount,
    _successGetUsersCount,
    _errorGetUsersCount,
    _finallyGetUsersCount,
    _successGetCompanyFeaturesAndAddons
  }
  this.getApi = () => api

  activate()

  function activate () {
    $rootScope.getUserCompany().then(api._getUsersCount)
    $rootScope.getCompanyFeaturesAndAddons().then(api._successGetCompanyFeaturesAndAddons)
  }

  const deregisterLicenseCardUpdate = $scope.$on('license-card.update', () => {
    api._getUsersCount($rootScope.oUserCompany)
  })

  $scope.$on('$destroy', () => {
    deregisterLicenseCardUpdate()
  })

  $scope.getAvailablePercentage = (maxLicenses, convertToInt) => {
    return api._getPercentage($scope.totalAvailable, maxLicenses, convertToInt)
  }

  $scope.openRequestQuote = function () {
    api.getRequestQuoteDialogController().then(({ RequestQuoteDialogController }) => {
      const requestQuoteDialog = UdsModalService.createModal({
        controller: RequestQuoteDialogController,
        modalName: 'requestQuoteDialog',
        data: {
          status: $scope.graphicColor,
          planName: $scope.planName
        }
      })

      requestQuoteDialog.open()
    })
  }

  function _getPercentage (value, total, convertToInt) {
    const multiplier = 100
    const expression = (multiplier * value) / total

    if (expression < 0) {
      return 0
    }

    if (convertToInt) {
      return parseInt(expression)
    }

    return expression
  }

  function _buildGraphic (maxLicenses) {
    const graphic = $('.license-card-container .license-graphic')
    let pendingPercentage = $scope.pendingUsers
      ? api._getPercentage($scope.pendingUsers, maxLicenses)
      : 0
    let activePercentage = $scope.activeUsers
      ? api._getPercentage($scope.activeUsers, maxLicenses)
      : 0
    let unavailablePercentage = $scope.totalUnavailable
      ? api._getPercentage($scope.totalUnavailable, maxLicenses)
      : 0
    const totalPercentage = $scope.totalAvailable
      ? api._getPercentage($scope.totalAvailable, maxLicenses)
      : 0

    if (unavailablePercentage > 100) {
      pendingPercentage = api._getPercentage(pendingPercentage, unavailablePercentage)
      activePercentage = api._getPercentage(activePercentage, unavailablePercentage)
      unavailablePercentage = 100
    }

    if ($scope.pendingUsers) {
      graphic.find('.pending').css('width', `${pendingPercentage}%`)
    }

    if ($scope.activeUsers) {
      const cssValue = $scope.pendingUsers ? `calc(${activePercentage}% + 12px)` : `${activePercentage}%`
      graphic.find('.active').css('width', cssValue)

      if ($scope.pendingUsers) {
        graphic.find('.active').css('margin-left', '-12px')
      }
    }

    if ($scope.totalUnavailable) {
      graphic.find('.total').css('width', `${unavailablePercentage}%`)
    }

    if ($scope.totalAvailable) {
      const cssValue =
        $scope.pendingUsers || $scope.activeUsers ? `calc(${totalPercentage}% + 12px)` : `${totalPercentage}%`
      graphic.find('.available').css('width', cssValue)

      if ($scope.pendingUsers || $scope.activeUsers) {
        graphic.find('.available').css('margin-left', '-12px')
      }
    }
  }

  function _defineGraphicColor (maxLicenses) {
    const available = $scope.getAvailablePercentage(maxLicenses)

    if (available < 10) {
      $scope.graphicColor = 'critical'
    } else if (available < 30) {
      $scope.graphicColor = 'alert'
    } else {
      $scope.graphicColor = 'default'
    }
  }

  function _getUsersCount (userCompany) {
    $scope.flags.loading = true
    $scope.flags.error = false

    AdminService.filterUsersCount({ hideInternalUsers: true })
      .then((response) =>
        api._successGetUsersCount(response, userCompany.maxLicenses)
      )
      .catch(api._errorGetUsersCount)
      .finally(api._finallyGetUsersCount)
  }

  function _successGetUsersCount (response, maxLicenses) {
    $scope.activeUsers = parseInt(response.active)
    $scope.pendingUsers = parseInt(response.pending_invite)
    $scope.totalUnavailable = $scope.activeUsers + $scope.pendingUsers
    $scope.totalAvailable = maxLicenses - $scope.totalUnavailable

    api._buildGraphic(maxLicenses)
    api._defineGraphicColor(maxLicenses)
  }

  function _errorGetUsersCount (error) {
    $timeout(() => {
      $scope.flags.error = true
      ToastService.defaultErrorToast()
      console.error({ error })
    }, 500, true)
  }

  function _finallyGetUsersCount () {
    $timeout(() => {
      $scope.flags.loading = false
    }, 500, true)
  }

  function _successGetCompanyFeaturesAndAddons ({ name }) {
    $scope.planName = name
  }
}

export { LicenseCardController }
